import React, { useMemo, useState } from 'react';
import CHANGELOG from '../../data/changelog';

// Read-only change log for admin/system (System Setting › Log Perubahan). Content lives in data/changelog.js.
const ALL = 'Semua';

const ChangelogView = () => {
    const [area, setArea] = useState(ALL);
    const [keyword, setKeyword] = useState('');

    const areas = useMemo(() => {
        const found = new Set();
        CHANGELOG.forEach((day) => day.items.forEach((item) => found.add(item.area)));
        return [ALL, ...[...found].sort((a, b) => a.localeCompare(b, 'ms'))];
    }, []);

    const days = useMemo(() => {
        const needle = keyword.trim().toLowerCase();
        return CHANGELOG
            .map((day) => ({
                ...day,
                items: day.items.filter((item) => (
                    (area === ALL || item.area === area)
                    && (!needle || `${item.title} ${item.detail} ${item.area}`.toLowerCase().includes(needle))
                )),
            }))
            .filter((day) => day.items.length > 0);
    }, [area, keyword]);

    const total = days.reduce((sum, day) => sum + day.items.length, 0);

    return (
        <div className="app-section">
            <div className="app-section-header">
                <div>
                    <div className="app-section-eyebrow">SYSTEM SETTING</div>
                    <h2>Log Perubahan</h2>
                    <p>Rekod perubahan sistem i-SYAEMS, yang terbaharu di atas. Paparan ini untuk bacaan sahaja.</p>
                </div>
            </div>

            <div className="app-card">
                <div className="app-tab-panel">
                    <div className="app-form-grid">
                        <label className="app-form-field">
                            <span>Bahagian</span>
                            <select id="changelog-area" value={area} onChange={(event) => setArea(event.target.value)}>
                                {areas.map((name) => <option key={name} value={name}>{name}</option>)}
                            </select>
                        </label>
                        <label className="app-form-field app-span-full">
                            <span>Cari</span>
                            <input
                                id="changelog-search"
                                type="search"
                                value={keyword}
                                placeholder="Cari perubahan, contoh: PDF, statistik, WhatsApp"
                                onChange={(event) => setKeyword(event.target.value)}
                            />
                        </label>
                    </div>
                    <p className="app-muted" style={{ margin: '.5rem 0 0', fontSize: '.85rem' }}>
                        {total} perubahan dipaparkan{area !== ALL || keyword.trim() ? ' (ditapis)' : ''}.
                    </p>

                    {days.length === 0 && <div className="app-empty">Tiada perubahan sepadan dengan tapisan.</div>}

                    <div className="app-changelog">
                        {days.map((day) => (
                            <section className="app-changelog-day" key={day.date}>
                                <div className="app-changelog-date">
                                    <h4>{day.date}</h4>
                                    <span>{day.items.length} perubahan</span>
                                    {day.note && <p>{day.note}</p>}
                                </div>
                                <ul className="app-changelog-items">
                                    {day.items.map((item) => (
                                        <li key={`${day.date}-${item.title}`}>
                                            <span className="app-changelog-area">{item.area}</span>
                                            <strong>{item.title}</strong>
                                            <p>{item.detail}</p>
                                        </li>
                                    ))}
                                </ul>
                            </section>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangelogView;
